import { Card } from "@/components/ui/card";
import { ReactNode } from "react";

interface ToolCardContainerProps {
  children: ReactNode;
}

const ToolCardContainer = ({ children }: ToolCardContainerProps) => {
  return (
    <Card className="group relative p-5 bg-white hover:bg-gray-50/80 border border-gray-100 
                     shadow-sm hover:shadow-md transition-all duration-300 rounded-xl overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 via-transparent to-pink-500/5 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
      {children}
    </Card>
  );
};

export default ToolCardContainer;